import { render } from "./OpenRhWeb.vue?vue&type=template&id=6c15f8da"
import script from "./OpenRhWeb.vue?vue&type=script&lang=js"
export * from "./OpenRhWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__